import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import { gray, primary } from "../../colors";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { useEffect } from "react";
import childrenList from "../../api/get/childrenList";
import { useState } from "react";
import MyButton from "../custom/MyButton";

export default function WelcomeUser({ name, active }) {
  const navigation = useNavigation();
  const [haveChildren, setHaveChildren] = useState(true);
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      childrenList().then(({ data }) => {
        if (data.status === 200)
          data.data.length > 0 ? setHaveChildren(true) : setHaveChildren(false);
      });
    }
  }, [isFocused]);
  return (
    <View
      style={{
        marginHorizontal: 5,
        marginVertical: 20,
        width: "92%",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <View>
          <MyText
            style={{
              marginHorizontal: 5,
              fontWeight: "bold",
              fontSize: 18,
              color: primary,
            }}
          >
            {name === null || name === undefined || name === ""
              ? translate("user")
              : name}
          </MyText>
        </View>
        <View>
          <MyText style={{ fontWeight: "bold", fontSize: 18 }}>
            {translate("welcome")}
          </MyText>
        </View>
      </View>
      {active && !haveChildren && (
        <View style={{ marginTop: 10 }}>
          <MyText style={{ fontSize: 14, color: gray }}>
            {translate("ChildrenNotComplete")}
          </MyText>
        </View>
      )}
      {active && !haveChildren && (
        <View
          style={{
            marginTop: 25,
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <MyButton
            onPress={() => navigation.navigate("NewChildGenderChoose")}
            style={{ paddingVertical: 5 }}
            text={translate("add children")}
          />
        </View>
      )}
      {!active && (
        <View
          style={{
            marginTop: 25,
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <TouchableOpacity
            onPress={() => navigation.navigate("UserRegister")}
            style={{
              borderRadius: 15,
              padding: 10,
              backgroundColor: primary,
              flexDirection: "row",
            }}
          >
            <MyText
              style={{
                color: "white",
              }}
            >
              {translate("signup")}
            </MyText>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
}
